import { c as _c } from "react/compiler-runtime";
import { Input } from "@/components/rhf/input";
import { useMemo } from "react";
import { Control } from "react-hook-form";
import type { AddressFormData } from "./hooks/useAddressMap";
import { cities } from "./map/configs";
interface AddressFormFieldsProps {
  control: Control<AddressFormData>;
  propertyType?: {
    type: string;
  };
  isCommunity: boolean;
  isDisabled: Partial<Record<string, boolean>>;
  isProjectSupported?: boolean;
}
export function AddressFormFields(t0) {
  const $ = _c(35);
  const {
    control,
    propertyType,
    isCommunity,
    isDisabled,
    isProjectSupported
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cities.map(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const cityOptions = t1;
  let t2;
  if ($[1] !== isCommunity || $[2] !== propertyType?.type) {
    t2 = () => {
      const type = isCommunity ? "Society" : propertyType?.type === "house" ? "House" : "Project";
      return `${type} Name *`;
    };
    $[1] = isCommunity;
    $[2] = propertyType?.type;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  propertyType?.type;
  const projectLabel = t2();
  propertyType?.type;
  const type_0 = isCommunity ? "Society" : propertyType?.type === "house" ? "House" : "Project";
  const projectPlaceholder = `Enter ${type_0} name`;
  let t3;
  if ($[4] !== control || $[5] !== isDisabled.projectName || $[6] !== isProjectSupported || $[7] !== projectLabel || $[8] !== projectPlaceholder) {
    t3 = isProjectSupported && <Input control={control} name="projectName" label={projectLabel} placeholder={projectPlaceholder} rules={{
      required: "Project name is required"
    }} disabled={isDisabled.projectName} />;
    $[4] = control;
    $[5] = isDisabled.projectName;
    $[6] = isProjectSupported;
    $[7] = projectLabel;
    $[8] = projectPlaceholder;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== control) {
    t4 = <div className="grid grid-cols-2 gap-4"><Input control={control} name="flatNumber" label="Flat No" placeholder="e.g. A-101" /><Input control={control} name="blockName" label="Block/Tower" placeholder="e.g. Block A" /></div>;
    $[10] = control;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      required: "Locality is required"
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = isDisabled["location.locality"];
  let t7;
  if ($[13] !== control || $[14] !== t6) {
    t7 = <Input control={control} name="location.locality" label="Locality *" placeholder="Kudlu" rules={t5} disabled={t6} />;
    $[13] = control;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = isDisabled["location.address"];
  let t9;
  if ($[16] !== control || $[17] !== t8) {
    t9 = <Input control={control} name="location.address" label="Address" placeholder="Enter full address" disabled={t8} />;
    $[16] = control;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      required: "City is required"
    };
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== control) {
    t11 = <Input control={control} name="location.city" label="City *" type="select2" options={cityOptions} placeholder="Bengaluru" rules={t10} disabled={true} />;
    $[20] = control;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      required: "Postal code is required"
    };
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = isDisabled["location.pin"];
  let t14;
  if ($[23] !== control || $[24] !== t13) {
    t14 = <Input control={control} name="location.pin" label="Postal code *" placeholder="560068" rules={t12} disabled={t13} />;
    $[23] = control;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t11 || $[27] !== t14) {
    t15 = <div className="grid grid-cols-2 gap-4">{t11}{t14}</div>;
    $[26] = t11;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t3 || $[31] !== t4 || $[32] !== t7 || $[33] !== t9) {
    t16 = <div className="space-y-4">{t3}{t4}{t7}{t9}{t15}</div>;
    $[29] = t15;
    $[30] = t3;
    $[31] = t4;
    $[32] = t7;
    $[33] = t9;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}
function _temp(t0) {
  const {
    _id,
    names
  } = t0;
  return {
    value: _id,
    label: names[0]
  };
}